import { render, staticRenderFns } from "./ProcessosAdvogadosStats.vue?vue&type=template&id=14584f52&"
import script from "./ProcessosAdvogadosStats.vue?vue&type=script&lang=js&"
export * from "./ProcessosAdvogadosStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports